import { useAIAgentLocationSettings } from 'app/components/ai-agent-location-settings/useAIAgentLocationSettings'
import { AIAgentLocationSettingsComponent } from 'app/components/ai-agent-location-settings/AIAgentLocationSettingsComponent'

export default function Settings() {
  const hookData = useAIAgentLocationSettings()
  return <AIAgentLocationSettingsComponent {...hookData} />
}
